module.exports = __webpack_public_path__ + "img/88bcf857c3e7b82330cf03a6d3453713.png";